import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/guidanceLabourers`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/guidanceLabourers/${id}`, options)
        .then(response => {
            let guidance = jsona.deserialize(response.data);
            delete guidance.links;
            return guidance;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/guidanceLabourers/${id}`, options)
        .then(response => {
            let guidance = jsona.deserialize(response.data);
            delete guidance.links;
            return guidance;
        });
}

function add (guidance) {
    const payload = jsona.serialize({
        stuff: guidance,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/guidanceLabourers`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (guidance) {
    const payload = jsona.serialize({
        stuff: guidance,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/guidanceLabourers/${guidance.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/guidanceLabourers/${id}`, options);
}

export default {
    list,
    get,
    show,
    add,
    update,
    destroy
};

